// utils/formHelpers.js

import axios from "axios";

export async function handleFormSubmit(url, formElement, setLoading, setError) {
  setLoading(true);
  setError(null);
  const userId = localStorage.getItem('userId');
  
  try {
    const formData = new FormData(formElement);
    // Append userId to the formData
    formData.append('userId', userId);

    // Convert formData to key-value pairs
    const formValues = {};
    formData.forEach((value, key) => {
      formValues[key] = value;
    });

    const response = await axios.post(url, formValues);
    
    // No need to check response.ok, axios will throw an error for non-2xx status codes.
    return response.data; // Return the actual response data from the server
  } catch (error) {
    setError(error.message || 'An error occurred');
    throw error; // Rethrow the error if you want to handle it in the calling function
  } finally {
    setLoading(false);
  }
}

export async function handleFormSubmit2(url, formElement, setLoading, setError) {
  setLoading(true);
  
  setError(null);
  
  try {
    const formData = new FormData(formElement);


    const response = await fetch(url, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error('Failed to submit the data. Please try again.');
    }

    const data = await response.json();
    return data; // Return data for further handling if necessary
  } catch (error) {
    setError(error.message);
    throw error; // Rethrow the error if you want to handle it in the calling function
  } finally {
    setLoading(false);
  }
}
  